import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, shareReplay, catchError } from 'rxjs/operators';
import { environment } from "../../../environments/environment";
import { Router } from '@angular/router';

import { EstatusResponse } from '../interfaces/meta-defender/meta-defender-response.interface';


@Injectable({
  providedIn: 'root'
})
export class EscaneoApiService {

  constructor(private http: HttpClient) { }

  postEscanearAntivirus(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    const headers = new HttpHeaders({
      'apikey': environment.apiKeyMetaDefender
    });

    return this.http
      .post<any>(`${environment.apiMetaDefender}/v4/file`, formData, {headers})
      .pipe(shareReplay(1))
  }

  getAnalisisResultado(dataId: string) {
    const headers = new HttpHeaders({
      'apikey': environment.apiKeyMetaDefender
    }); 

    return this.http
      .get<EstatusResponse>(`${environment.apiMetaDefender}/v4/file/${dataId}`, {headers})
  }
}